import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import {
	BusinessPartner,
	BusinessPartnerContactPerson,
	BusinessPartnerRelation,
} from '@oe-backend/types';
import { map } from 'rxjs/operators';
import { ResponseObjectApiInterface } from 'src/app/types/interfaces/api-responses/response-object.api.interface';
import { BaseApiService } from '../../base-api/base-api.service';

@Injectable({
	providedIn: 'root',
})
export class ECPService extends BaseApiService {
	private http = inject(HttpClient);

	fetchSoldToStores() {
		return this.http
			.get<ResponseObjectApiInterface<BusinessPartner[]>>(`${this.apiBaseUrl}/ECPs/Stores`)
			.pipe(
				map((response: ResponseObjectApiInterface<BusinessPartner[]>) => {
					return response.data;
				}),
			);
	}

	fetchShipToStores() {
		return this.http
			.get<
				ResponseObjectApiInterface<BusinessPartnerRelation[]>
			>(`${this.apiBaseUrl}/ECPs/Shipping`)
			.pipe(
				map((response: ResponseObjectApiInterface<BusinessPartnerRelation[]>) => {
					return response.data;
				}),
			);
	}

	fetchContactPersons(shipToNumber: number) {
		return this.http
			.get<
				ResponseObjectApiInterface<BusinessPartnerContactPerson[]>
			>(`${this.apiBaseUrl}/ECPs/Shipping/${shipToNumber}/contactPersons`)
			.pipe(
				map((response: ResponseObjectApiInterface<BusinessPartnerContactPerson[]>) => {
					return response.data;
				}),
			);
	}
}
